import { Invoice, InvoiceColumnTypes } from 'src/app/invoice-data/invoice-data.model';

import { DateRange } from '../../shared/models/date-range.model';

export enum InvoiceView {
  overview = 'overview',
  detailedOverview = 'detailedOverview',
  totals = 'totals',
}

export const invoiceColumns = [
  InvoiceColumnTypes.invoiceDate,
  InvoiceColumnTypes.externalInvoiceId,
  InvoiceColumnTypes.allShipToIds,
  InvoiceColumnTypes.invoiceDescription,
  InvoiceColumnTypes.brutoAmount,
] as const;

export type InvoiceOverviewViewModel = Pick<
  Invoice,
  (typeof invoiceColumns)[number] | 'id' | 'shipToId'
>;

export interface InvoiceOverviewDataFilters {
  locations: number[];
  search: string;
  dateRange: DateRange;
}
